module.exports = __webpack_public_path__ + "img/crystal@2x.5ce02d4.jpg";